import React from 'react'
import renderHTML from 'react-render-html'

import BkFlowRoomCardAdaDescriptionModal from './BkFlowRoomCardAdaDescriptionModal'
import BkFlowRoomCardAdaDescriptionAccordion from './BkFlowRoomCardAdaDescriptionAccordion'

import '../../../../styles/css/components/room/bk-flow-room-card-ada-description.css'

const BkFlowRoomCardAdaDescription = props => {
	const {
		adaDisclaimer,
		hotelLabels,
		toggledState,
		toggleEvent
	} = props

	return (
		process.env.REACT_APP_COMPONENT_ROOM_ACCESSIBLE_DETAILS_COMPONENT === 'modal' &&
		toggleEvent ? (
			<BkFlowRoomCardAdaDescriptionModal
				adaDisclaimer={adaDisclaimer}
				hotelLabels={hotelLabels}
				toggledState={toggledState}
				toggleEvent={toggleEvent}
			/>
		)	: toggleEvent ? (
			<BkFlowRoomCardAdaDescriptionAccordion
				adaDisclaimer={adaDisclaimer}
				hotelLabels={hotelLabels}
				toggledState={toggledState}
				toggleEvent={toggleEvent}
			/>
		) : (
			<div className="bk-flow-room__card-ada-description">
				<div className="bk-flow-room__card-ada-description-content">{ renderHTML(adaDisclaimer) }</div>
			</div>
		)
	)
}

export default BkFlowRoomCardAdaDescription



// WEBPACK FOOTER //
// ./src/components/room/elements/accessiblity/BkFlowRoomCardAdaDescription.js